<div class="dialog">
  <div class="dialog-top">
    <h2 class="dialog-title short-text">  {{local_data.title}}  </h2>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-button" mat-dialog-close>
      <circle opacity="0.05" cx="20" cy="20" r="20" fill="#0080FF"/>
      <path opacity="0.8" d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z" fill="#0080FF"/>
    </svg>
  </div>
  <mat-dialog-content class="dialog-flex">
    <form [formGroup]="formGroup">
      <div class="dialog-box">
        <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.name }}</label>
        <mat-form-field [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
          class="form-field" appearance="outline">
          <input type="text" matInput formControlName="nameCtrl">
          @if (invalidInput) {
            <mat-hint class="error-hint">{{variables.alreadyExists}}</mat-hint>
          }
          @if (formGroup.get('nameCtrl')?.hasError('required')) {
            <mat-error>{{ variables.mandatoryTechNameField }}</mat-error>
          }
        </mat-form-field>
        @if (local_data.edit) {
          <label class="mb-2 input-label">{{ variables.state }}</label>
        }
        @if (local_data.edit) {
          <mat-radio-group [(ngModel)]="local_data.tecActive" class="form-field" formControlName="techActiveCtrl"><br>
            <mat-radio-button [value]="true">{{variables.active}}</mat-radio-button><br>
            <mat-radio-button class="ml-3" [value]="false">{{variables.inactive}}</mat-radio-button>
          </mat-radio-group>
        }
      </div>
    </form>
    <div class="dialog-box-s">
      <mat-dialog-actions class="button-group">
        <app-button typeBtn="secondary" color="red" textColor="white" message="{{ variables.goBack }}" mat-dialog-close></app-button>
        <app-button typeBtn="primary" (click)="doAction()" message="{{ variables.save }}"></app-button>
      </mat-dialog-actions>
    </div>
  </mat-dialog-content>
</div>
